import { FormattedMessage } from 'react-intl';
import { Tooltip } from '../../../../ui/tooltip/Tooltip';
import { VariableRate } from '../../../../ui/rate/Rate';
import LoadingCalculationValue from '../../../../multiLoanDashboard/dashboardComponents/loadingDashboardValue/LoadingDashboardValue';
import SummaryRow from '../../../../ui/summaryRow/SummaryRow';
import messages from './WithdrawalFee.messages';
import styles from './WithdrawalFee.module.css';

const WithdrawalFee = ({ withdrawalFee, className }) => {
    return (
        <SummaryRow data-testid="withdrawal-fees" className={className}>
            <FormattedMessage
                {...messages.withdrawalFee}
                values={{
                    tooltip: (
                        <Tooltip
                            message={
                                <FormattedMessage {...messages.feeTooltip} />
                            }
                            className={styles.tooltip}
                        />
                    )
                }}
            />

            <LoadingCalculationValue>
                <div>
                    {withdrawalFee === 0 && (
                        <span className={styles.always}>
                            <FormattedMessage {...messages.always} />
                        </span>
                    )}

                    <VariableRate
                        minimumFractionDigits={0}
                        maximumFractionDigits={2}
                        value={withdrawalFee}
                    />
                </div>
            </LoadingCalculationValue>
        </SummaryRow>
    );
};

// eslint-disable-next-line import/no-default-export
export default WithdrawalFee;
